import TimeAgo from 'react-timeago';
import { LONG_DATETIME_FORMAT } from '~/constants';
import { formatDate } from '~/utils';

import { ColumnHelperMethodType } from '../SearchContentTable.types';
import { TextCell } from '../components/TextCell';

export const ColumnPublishedAt: ColumnHelperMethodType = (columnHelper) =>
  columnHelper.accessor((row) => row.contentId, {
    id: 'publishedAt',
    cell: ({ row }) => (
      <TextCell>
        <TimeAgo
          date={row.original.publishedAt}
          title={formatDate(row.original.publishedAt, LONG_DATETIME_FORMAT)}
        />
      </TextCell>
    ),
    header: () => <>Posted</>,
  });
